
<h1 mat-dialog-title>{{title}}</h1>
<div mat-dialog-content>{{message}}</div>
<mat-progress-bar *ngIf="showProgress" mode="indeterminate"></mat-progress-bar>



// WEBPACK FOOTER //
// ./src/services/splash/splash.component.ts.SplashDialogComponent.html